import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export default function ConfirmDeleteDialog({
  open,
  title = 'Confirmer la suppression',
  itemLabel = 'cet élément',
  description,
  loading = false,
  onClose,
  onConfirm,
}) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="xs">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {description || `Tu es sûr de vouloir supprimer ${itemLabel} ?`}
        </DialogContentText>
        <Alert severity="warning" sx={{ mt: 2 }}>
          Cette action est définitive.
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Annuler
        </Button>
        <Button color="error" variant="contained" onClick={onConfirm} disabled={loading}>
          {loading ? 'Suppression…' : 'Supprimer'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
